function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Modal from '@nextcloud/vue/dist/Components/Modal';
import Multiselect from '@nextcloud/vue/dist/Components/Multiselect';
import moment from 'moment';
export default {
  name: 'ModalItem',
  components: {
    Modal: Modal,
    Multiselect: Multiselect
  },
  props: {
    header: {
      type: Array,
      default: null
    },
    entityName: {
      type: String,
      default: 'item'
    },
    itemData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    icon: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    inputMode: {
      type: String,
      default: 'add' // add or edit

    }
  },
  data: function data() {
    return {
      values: {},
      showModal: false
    };
  },
  watch: {
    itemData: function itemData(newItemData) {
      // console.debug('newItemData', newItemData)
      this.resetValues();
    }
  },
  mounted: function mounted() {
    this.resetValues();
  },
  methods: {
    sendData: function sendData() {
      var _this = this;

      // console.debug('modal transform values', this.values)
      for (var _i = 0, _Object$entries = Object.entries(this.values); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
            key = _Object$entries$_i[0];

        if (this.values[key] && Number.isInteger(this.values[key].id)) {
          this.values[key] = this.values[key].id;
        } else if (Array.isArray(this.values[key])) {
          (function () {
            var d = [];

            _this.values[key].forEach(function (item) {
              // console.debug('entry', { item: item, i: i })
              d.push(item);
            });

            _this.values[key] = JSON.stringify(d);
          })();
        }
      } // console.debug('modal send values', this.values)


      this.$emit('addItem', this.values);
      this.resetValues();
      this.showModal = false;
    },
    isNewSection: function isNewSection(index) {
      // try to get header data
      if (!this.header[index]) {
        return false;
      } // if there is a section definition, else false


      if (this.header[index].section) {
        // get last section definition or false
        var lastSection = false;
        var i = 1;

        while (this.header[index - i]) {
          if (this.header[index - i].show) {
            if (this.header[index - i].section) {
              lastSection = this.header[index - i].section;
            }

            break;
          }

          i++;
        }

        if (lastSection && lastSection.id !== this.header[index].section.id) {
          return true;
        }
      }

      return false;
    },
    closeModal: function closeModal() {
      this.resetValues();
      this.showModal = false;
    },
    resetValues: function resetValues() {
      var _this2 = this;

      // console.debug('reset values in modal')
      this.values = Object.assign({}, this.itemData);
      this.header.forEach(function (h) {
        if ('default' in h && h.default instanceof Function && !(h.columnId in _this2.values)) {
          _this2.values[h.columnId] = h.default();
        }

        if (h.columnId === 'date') {
          // this.values[h.columnId] = new Date(this.values[h.columnId]).toISOString().slice(0, 10)
          _this2.values[h.columnId] = moment(_this2.values[h.columnId]).format('YYYY-MM-DD');
        }

        if (h.columnId === 'datetime' || h.columnId === 'asleep' || h.columnId === 'wakeup') {
          _this2.values[h.columnId] = moment(_this2.values[h.columnId]).format('YYYY-MM-DDTHH:mm');
        }

        if (h.type === 'multiselect') {
          if (typeof _this2.values[h.columnId] === 'string') {
            _this2.values[h.columnId] = JSON.parse(_this2.values[h.columnId]);
          }
        }
      });
    }
  }
};